/*
  Starts native-lazy images about 1500px before their section reaches the
  viewport. Native lazy loading alone waits too long inside horizontal
  scrollers and in Safari, so cards appeared before their images.

  Covers every section in the main content area and footer, plus any
  [data-preload-near] container. Header/menu images are left alone so hidden
  mega-menu images don't download, and images that aren't rendered (e.g. tiles
  hidden on mobile, closed modals) keep normal lazy behavior.

  Loaded site-wide from snippets/new-tab.liquid; some sections also include
  it. It only runs once.
*/
(function () {
  if (window.__zdPreloadNear) return;
  window.__zdPreloadNear = true;

  var TARGETS = '#MainContent .shopify-section, .shopify-section-group-footer-group, [data-preload-near]';

  function start(root) {
    root.querySelectorAll('img[loading="lazy"]').forEach(function (img) {
      if (img.getClientRects().length === 0) return; // not rendered
      img.loading = 'eager';
    });
  }

  var io =
    'IntersectionObserver' in window
      ? new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                start(entry.target);
                io.unobserve(entry.target);
              }
            });
          },
          { rootMargin: '1500px 0px' }
        )
      : null;

  function observe(scope) {
    var els = scope.matches && scope.matches(TARGETS) ? [scope] : [];
    scope.querySelectorAll(TARGETS).forEach(function (el) {
      els.push(el);
    });
    els.forEach(function (el) {
      if (io) io.observe(el);
      else start(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      observe(document);
    });
  } else {
    observe(document);
  }

  // The theme editor re-renders a section in place when its settings change.
  document.addEventListener('shopify:section:load', function (event) {
    observe(event.target);
  });
})();
